import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { SplitViewHeader } from './split-view-header.atom'

export interface SplitViewWrapperProps {
  title: string
  subtitle?: string
  icon?: ReactNode
  onClose: () => void
  onTitleClick?: () => void
  isCloseButtonHidden?: boolean
  className?: string
  children: ReactNode
}

export const SplitViewWrapper: React.FC<SplitViewWrapperProps> = ({
  title,
  subtitle,
  icon,
  onClose,
  onTitleClick,
  isCloseButtonHidden = false,
  className,
  children,
}): ReactNode => (
  <div className={cn('split-view-container flex h-full min-h-0 flex-col bg-background', className)}>
    <SplitViewHeader
      title={title}
      subtitle={subtitle}
      icon={icon}
      onClose={onClose}
      onTitleClick={onTitleClick}
      isCloseButtonHidden={isCloseButtonHidden}
    />
    <div className="split-view-body min-h-0 flex-1 overflow-hidden">{children}</div>
  </div>
)
